import { render } from "./new-app-link.vue?vue&type=template&id=14089760&scoped=true"
import script from "./new-app-link.vue?vue&type=script&lang=js"
export * from "./new-app-link.vue?vue&type=script&lang=js"

import "./new-app-link.vue?vue&type=style&index=0&id=14089760&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14089760"]])

export default __exports__